import React from 'react'
import axios from 'axios'

import Cabecalho from '../CabecalhoView/Cabecalho'
import './DespachoView.css'

const initialState = {
    list: [],
    numero: ''
}

export default class DespachoView extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/despacho/getDespachos/${id}`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data.despacho })
                this.setState({ numero: resp.data.numero })
                this.setState({ estado: resp.data.estado })
            })
            .catch(error => {
                alert(error)
            }
            )
    }

    render() {
        return (
            <React.Fragment>
                <Cabecalho estado={this.state.estado} />
                <h2 className="mt-4">Despacho</h2>
                <div className="topo">
                    <div>Processo nº {this.state.numero}</div>
                    <div>Fiscalizado: {this.state.list.fiscalizado}</div>
                    <div>Responsável Técnico: {this.state.list.responsavel}</div>
                </div>
                <div className="paragrafo">
                    <p>{this.state.list.texto}</p>
                </div>
                <div className="identificacao">
                    <p>{this.state.list.user}</p>
                    {this.renderFuncao()}
                </div>
            </React.Fragment>
        )
    }

    renderFuncao() {
        const profissao = this.state.list.fonte
        if(profissao == "coordenacao") {
            return (
                <p>Coordenação Geral do DEFIS</p>
            )
        }
        else if(profissao == "coordenacao_pb") {
            return (
                <p>Coordenação Geral</p>
            )
        }
        else if(profissao == "defis") {
            return (
                <p>Membro DEFIS - Coordenação {this.state.list.estado}</p>
            )
        }
        else if(profissao == "administrativo") {
            return (
                <p>Assistente Administrativo</p>
            )
        }
        else if(profissao == "presidencia") {
            return (
                <p>Presidência</p>
            )
        }
        else if(profissao == "vice-presidencia") {
            return (
                <p>Vice-Presidência</p>
            )
        }
        else if(profissao == "fiscal") {
            return (
                <p>Fiscal</p>
            )
        }
        else if(profissao == "juridico") {
            return (
                <p>Assessoria Jurídica</p>
            )
        }
    }
}